import { FC } from 'react';

import MailIcon from '@/assets/svg/ui-elements/mail-open-green.svg';
import { theme, Typography } from '@/shared/design-system';

import { InvitationCard, InvitationEmail } from './team-member-add.styled';

export const TeamMemberAddInvitationInfo: FC<{ email: string }> = ({ email }) => (
  <InvitationCard>
    <MailIcon />

    <Typography variant="body1" color={theme.colors.text.primary}>
      This user has received an invitation email.
    </Typography>

    <InvitationEmail>
      <Typography variant="body3" color={theme.colors.text.secondary}>
        {email}
      </Typography>
    </InvitationEmail>

    <Typography variant="body3" color={theme.colors.text.secondary}>
      The user will be shown as Pending until they create their Gamma Prime profile. After profile
      creation, the user will be shown as “Waiting for Approval” in the Team Management Dashboard.
    </Typography>
  </InvitationCard>
);
